import { app } from './app.js'

app.$mount('#app')
